// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZDFd","toggleWrap":"styles_toggleWrap__zJ_jO","content":"styles_content__F394d","selectAreaCode":"styles_selectAreaCode__3fjvi"};